<template>
  <div>

    <admin-filter
      :items="filterData"
      :itemFiltered.sync="filtered"
      @getData="getDataFromServer"
      title="파트너 기획전 조회"
      desc="등록된 파트너 기획전의 현황을 조회할 수 있습니다."
    ></admin-filter>

    <div class="btn-group-justify-end">
      <button @click="$router.push('exhibition_partner/create')"
              class="button is-primary" style="width: auto">파트너 기획전 등록</button>
    </div>

    <admin-table :field_list="tableData"
                 :items="tableItems"
                 :filtered="filtered"
                 :allCount="allCount"
                 :filteredCount="filteredCount"
                 @getData="getDataFromServer"
                 @ordering="ordering"
                 :table_width="1650"
                 @selPageLength="selPageLength">

      <div slot="partner_list" slot-scope="props" style="text-align:left">
        <div v-for="(partner, idx) in props.item.partner_list"
             :key="'partner-'+idx"
             class="flex-align"
             style="margin-bottom:4px">
          <div :style="imgField(partner.first_img)" v-if="partner.first_img"></div>
          <span style="max-width:130px">{{ partner.name }}</span>
          <!--<span v-if="idx < props.item.partner_list.length-1">,</span>--></div>
      </div>

      <div slot="display_type" slot-scope="props">
        <div v-if="props.item.display_type===0">노출</div>
        <div v-else-if="props.item.display_type===1">기간별 노출</div>
        <div v-else-if="props.item.display_type===2">노출안함</div>
      </div>

      <div slot="start_date" slot-scope="props">
        <div v-if="props.item.display_type===1">{{props.item.start_date}}</div>
      </div>

      <div slot="end_date" slot-scope="props">
        <div v-if="props.item.display_type===1">{{props.item.end_date}}</div>
      </div>

      <div slot="modify_delete" slot-scope="props">
        <button class="button half"
                @click.stop.prevent="clickItem(props.item,'update')" style="margin-right:4px">수정</button>
        <button class="button half is-danger"
                @click.stop.prevent="clickItem(props.item,'delete')" v-if="showItem(props.item.index)">삭제</button>
      </div>

    </admin-table>
  </div>
</template>

<script>
  import ListMixin from '@/mixins/ListMixin'

  export default {
    name: 'ExhibitionPartnerList',
    mixins: [
      ListMixin
    ],

    created() {
      this.init();
    },

    methods: {
      init () {
        this.initializing('exhibition_partner', 'exhibition_partner');
      },
      getDataFromServer() {
        this.getData();
      },
      imgField(img) {
        return 'background-image: url('+this.image(img)+');' +
          ' width: 20px; height: 20px; background-size: cover;' +
          ' background-position: center; margin-right: 8px';
      },
      showItem(index) {
        let show = true;
        if(this.checkServiceVersion(2)) show = true;
        else if(index<5) {
          show = false;
        }
        return show;
      },
      clickItem(item, kind) {
        if ( kind === 'update' ) {
          this.$router.push(this.getPath('exhibition_partner/create?id='+item.id));
        }
        else if ( kind === 'delete' ) {
          let value = {
            id: item.id,
            url: 'exhibition_partner/',
            title: '파트너 기획전을 삭제하시겠습니까?'
          }

          this.$store.commit('openModal', {type: 'modal-delete', value: value, width: 500});
        }
      },

      deleteItem(){
        this.$axios.delete(this.getUrl('exhibition_partner') + this.modalItem)
          .then(res => {
            if (res.status === 200) {

            }
          });
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>

</style>
